import { queryOptions } from '@tanstack/react-query';
import { getBanner } from '~/apis/mercari/get-banner';

const HOME_BANNERS_QUERY_KEY = ['home', 'banners'];

export const bannersOptions = (params: Parameters<typeof getBanner>[0]) => {
  return queryOptions({
    queryKey: [...HOME_BANNERS_QUERY_KEY, { ...params }],
    queryFn: () => getBanner(params),
    select: (data) => data?.data,
    staleTime: 1000 * 300, // 배너는 변경 가능성이 낮기 때문에 5분으로 설정
  });
};
